import { Coin } from './../../models/Coin';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CoinsProvider } from '../../providers/coins/coins';

/**
 * Generated class for the CoinChartSimpleComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'coin-chart-simple',
  templateUrl: 'coin-chart-simple.html'
})
export class CoinChartSimpleComponent {
  @Input('width') width: number;
  @Input('height') height: number;
  @Input('coin') coin: Coin;
  @Input('interval') interval: string;
  @Output('change') change: EventEmitter<number> = new EventEmitter<number>();

  prevInterval: string;
  currency: string;

  multi = [
    {
      "name": "",
      "series": []
    }
  ];

  view: any[] = [200, 200];

  // options
  showXAxis = false;
  showYAxis = false;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = 'Time';
  showYAxisLabel = false;
  yAxisLabel = 'Price';
  tooltipDisabled = false;
  colorScheme = {
    domain: ['#ffffff']
  };

  autoScale = true;

  constructor(private CP: CoinsProvider) {
  }

  ngOnInit(){
    this.view = [this.width, this.height];
  }

  getResults(){
    if(this.currency != this.CP.getCurrency() || this.prevInterval != this.interval){
      this.currency = this.CP.getCurrency();
      this.prevInterval = this.interval;
      this.CP.getDynamicChart(this.coin, this.interval).subscribe(data => {
        this.multi = [
          {
            "name": this.coin.Name,
            "series": data
          }
        ];
        this.getPercentChange(data);
      })
    }
    return this.multi;

  }

  getPercentChange(data): number{
    let pct = 0;
    if(data && data.length > 1){
      const first = data[0].value;
      const last = data[data.length - 1].value;
      pct = (last - first) / first * 100;
    }
    this.change.emit(pct);
    return pct;
  }

}



// WEBPACK FOOTER //
// ./src/components/coin-chart-simple/coin-chart-simple.ts